










import { Component, Mixins, Prop } from "vue-property-decorator";
import { TextItemOption } from "../../../../../domain/document/items";
import { TextStyle, TextAlignKinds } from "../../../../../domain/drawing";

@Component({
})
export default class ComboBoxMenuItemObject extends Mixins() {
  @Prop()
  item: TextItemOption;

  @Prop()
  textStyle: TextStyle;

  @Prop()
  isSelected: boolean;

  click() {
    this.$parent.$emit("comboBoxMenuItemSelected", this.item);
  }

  get itemStyleProperties() {
    return {
      color: this.item.textColor.value,
      backgroundColor: this.item.backgroundColor.value,
    };
  }

  get menuItemTextStyleProperties() {
    if (!this.textStyle) { return null; }
    return {
      fontSize: this.textStyle.baseFontSize + "px",
      fontFamily: this.textStyle.fontFamily,
      textAlign: this.toTextAlignValue(this.textStyle.textAlign),
    };
  }

  get wrapperClass(): string {
    return this.isSelected
      ? "selected-wrapper"
      : "wrapper";
  }

  private toTextAlignValue(kind: TextAlignKinds): string {
    if (kind & TextAlignKinds.Left) {
      return "left";
    } else if (kind & TextAlignKinds.Center) {
      return "center";
    } else if (kind & TextAlignKinds.Right) {
      return "right";
    }
    return null;
  }
}
